import Swal from "sweetalert2";
import { Col, Row } from 'react-bootstrap';
import { Field, Form } from 'react-final-form';
import React, { useState, useEffect } from 'react';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import renderSelectField from '@/shared/components/form/Select';
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';

const EditAsset = (props) => {
    const [stac, setStac] = useState();
    const [selectedAsset, setSelectedAsset] = useState();
    const [missionsList, setMissionsList] = useState();

    const submitStacUpdates = (stac) => {
        stac = JSON.parse(stac.stac)
        AdminInterface.instance.updateAssetStac(selectedAsset.uuid, stac).then((response) => {
            withReactContent(Swal).fire({
                title: "Success",
                text: "Asset STAC is updated!",
            });
            props.setListRequiresReload(true);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response?.data?.detail,
            });
        })
    };

    const submitAssetUpdates = (asset) => {
        let data = {};
        AdminInterface.instance.getMission(asset.mission.value).then((response) => {
            data.uuid = asset.uuid;
            data.mission = response.data;
            data.no_of_bands = asset.no_of_bands;
            data.mission_id = asset.mission.value;
            data.cog_file_uri = asset.cog_file_uri;
            AdminInterface.instance.updateAsset(selectedAsset.uuid, data).then(() => {
                withReactContent(Swal).fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Asset is updated!',
                });
                props.setSelectedAsset(null)
                props.setListRequiresReload(true);
            }).catch(() => {
                withReactContent(Swal).fire({
                    icon: 'error',
                    title: 'Error',
                    html: 'Error in updating the asset.',
                });
            })
        }).catch(() => {
            withReactContent(Swal).fire({
                icon: 'error',
                title: 'Error',
                html: 'Error in fetching mission data.',
            });
        })
    }

    const GetAssetStac = (uuid) => {
        AdminInterface.instance.getAssetStac(uuid).then((response) => {
            setStac(response.data);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response?.data?.detail,
            });
        });
    }

    const GetMissions = () => {
        AdminInterface.instance.getMissions().then((response) => {
            setMissionsList(response.data);
        }).catch(() => {
            withReactContent(Swal).fire({
                title: "Error",
                html: 'Error in loading Missions.',
            });
        })
    }

    useEffect(() => {
        if (missionsList == undefined) return;
        
        let asset = props.selectedAsset;
        for (let mission in missionsList) {
            if (missionsList[mission].id == asset.mission.id && missionsList[mission].collection_id == asset.mission.collection.id) {
                asset.mission = { value: props.selectedAsset.mission.id, label: `${asset.mission.collection.name} ${asset.mission.name}` }
                break;
            }
        }
        setSelectedAsset(asset);
    }, [stac]);

    useEffect(() => {
        if (missionsList == undefined) return;

        GetAssetStac(props.selectedAsset.uuid);
    }, [missionsList]);

    useEffect(() => {
        if (props.selectedAsset == undefined) return;

        GetMissions();
    }, [props.selectedAsset]);

    return (
        <Row>
            <Col md={6}>
                <Card>
                    <CardBody>
                        <CardTitleWrap>
                            <CardTitle>Edit Asset STAC</CardTitle>
                        </CardTitleWrap>
                        <Form onSubmit={submitStacUpdates} initialValues={{ stac: JSON.stringify(stac, null, 2) }}>
                            {({ handleSubmit, form }) => (
                                <FormContainer horizontal onSubmit={handleSubmit}>
                                    <FormGroup>
                                        <FormGroupLabel>STAC</FormGroupLabel>
                                        <FormGroupField>
                                            <Field name="stac" component="textarea" type="text" placeholder="STAC" rows={10} style={{ 'min-height': '300px' }} />
                                        </FormGroupField>
                                    </FormGroup>
                                    <FormButtonToolbar>
                                        <Button variant="primary" type="submit">Submit</Button>
                                        <Button variant="secondary" type="button" onClick={() => props.setSelectedAsset(null)}>
                                            Cancel
                                        </Button>
                                    </FormButtonToolbar>
                                </FormContainer>
                            )}
                        </Form>
                    </CardBody>
                </Card>
            </Col>
            <Col md={6}>
                <Card>
                    <CardBody>
                        <CardTitleWrap>
                            <CardTitle>Edit Asset</CardTitle>
                        </CardTitleWrap>
                        {selectedAsset && <Form onSubmit={submitAssetUpdates} initialValues={selectedAsset}>
                            {({ handleSubmit, form }) => (
                                <FormContainer horizontal onSubmit={handleSubmit}>
                                    <FormGroup>
                                        <FormGroupLabel>Mission</FormGroupLabel>
                                        <FormGroupField>
                                            <Field name="mission" component={renderSelectField}
                                                options={missionsList.map(function (mission) {
                                                    return { value: mission.id, label: `${mission.collection.name} ${mission.name}`}
                                                })}
                                            />
                                        </FormGroupField>
                                    </FormGroup>
                                    <FormGroup>
                                        <FormGroupLabel>No. Bands</FormGroupLabel>
                                        <FormGroupField>
                                            <Field name="no_of_bands" component="input" type="number" placeholder="Number of bands" />
                                        </FormGroupField>
                                    </FormGroup>
                                    <FormGroup>
                                        <FormGroupLabel>COG File URI</FormGroupLabel>
                                        <FormGroupField>
                                            <Field name="cog_file_uri" component="input" type="text" placeholder="File URI" />
                                        </FormGroupField>
                                    </FormGroup>
                                    <FormButtonToolbar>
                                        <Button variant="primary" type="submit">Submit</Button>
                                        <Button variant="secondary" type="button" onClick={() => props.setSelectedAsset(null)}>
                                            Cancel
                                        </Button>
                                    </FormButtonToolbar>
                                </FormContainer>
                            )}
                        </Form>}
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

export default EditAsset;